var map = {
	"./404.svg": 951,
	"./Categories.png": 952,
	"./Edit-menu.svg": 953,
	"./Egg.svg": 954,
	"./Emaier-Header.png": 955,
	"./Qr-4.png": 956,
	"./_duplicate.svg": 957,
	"./_overview.svg": 958,
	"./add-white.svg": 959,
	"./alert.svg": 960,
	"./all_category.svg": 961,
	"./archive.svg": 962,
	"./armchair.svg": 963,
	"./arrow-circle-right.svg": 964,
	"./arrow-left-circle.svg": 965,
	"./arrow-right-circle.svg": 966,
	"./arrow-right.svg": 967,
	"./asc-up-white.svg": 968,
	"./asc.png": 969,
	"./asc.svg": 970,
	"./back-arrow.svg": 971,
	"./barcode-icon.svg": 972,
	"./beverages.svg": 973,
	"./blue-edit-pen.svg": 974,
	"./blue-eye.svg": 975,
	"./box-office.svg": 976,
	"./broken-seat.jpg": 977,
	"./calendar_list.svg": 978,
	"./calender.svg": 363,
	"./chevron-down.svg": 979,
	"./chevron-left.svg": 980,
	"./cinema-mamagement-sidebar.svg": 981,
	"./claendar.svg": 312,
	"./clock-1.svg": 982,
	"./clock.svg": 983,
	"./close-button.svg": 716,
	"./close-white.svg": 718,
	"./close-x.svg": 307,
	"./collapse-up.svg": 984,
	"./collapse.svg": 985,
	"./connection-lost.svg": 361,
	"./consumable-raw-material.svg": 986,
	"./copy.svg": 987,
	"./copy_image_icon.png": 988,
	"./delete-red-light.svg": 989,
	"./delete-red.svg": 725,
	"./delete.svg": 699,
	"./deliver-icon.svg": 990,
	"./desc-down-white.svg": 991,
	"./desc.svg": 992,
	"./distributors-sidebar.svg": 993,
	"./download.svg": 994,
	"./dragndrop.svg": 995,
	"./dragndrop2.svg": 996,
	"./duplicate.svg": 997,
	"./duplicateScreen.svg": 998,
	"./e-wallet-icon-black.svg": 999,
	"./edit-pen-blue.svg": 1000,
	"./edit-pen-white.svg": 1001,
	"./edit-pen.svg": 1002,
	"./edit.svg": 1003,
	"./email.png": 1004,
	"./empty-image.svg": 1005,
	"./excel.svg": 1006,
	"./external-link.svg": 1007,
	"./eye.svg": 1008,
	"./filter-icon.svg": 1009,
	"./flag.svg": 1010,
	"./fnb-app-order.svg": 1011,
	"./fnb-beverages.svg": 1012,
	"./fnb-brownie.svg": 1013,
	"./fnb-combo.svg": 1014,
	"./fnb-desert.svg": 1015,
	"./fnb-eatables.svg": 1016,
	"./fnb-make-your-combo.svg": 1017,
	"./fnb-popcorn.svg": 1018,
	"./fnbtransactionIcon.svg": 1019,
	"./fullscreen-icon.svg": 726,
	"./funnel.svg": 1020,
	"./globe.svg": 1021,
	"./green-tick.svg": 1022,
	"./grid-view.svg": 1023,
	"./hide-password.svg": 364,
	"./home-icon.svg": 1024,
	"./home.svg": 1025,
	"./icon-black-play.svg": 1026,
	"./icon-dot.svg": 1027,
	"./icon-fnb.svg": 1028,
	"./icon-marketing.svg": 1029,
	"./icon-no-seat.png": 1030,
	"./icon-no-seat.svg": 1031,
	"./icon-option.svg": 1032,
	"./icon-poin-of-sale.svg": 1033,
	"./icon-recliner.svg": 1034,
	"./icon-report.svg": 1035,
	"./icon-sofa-dark-1.svg": 1036,
	"./icon-sofa-dark.png": 1037,
	"./icon-sofa-dark.svg": 1038,
	"./icon-sofa.svg": 1039,
	"./importfile.svg": 1040,
	"./info.svg": 719,
	"./info2.svg": 1041,
	"./keyboard-icon.svg": 1042,
	"./kitchen_display.svg": 1043,
	"./language-icon.svg": 365,
	"./left-caret.svg": 1044,
	"./link.svg": 1045,
	"./list-view.svg": 1046,
	"./loading.svg": 366,
	"./lock.svg": 1047,
	"./login-password.png": 367,
	"./login-user.png": 368,
	"./logout.svg": 720,
	"./masters-sidebar.svg": 1048,
	"./merchandise.svg": 1049,
	"./minus.svg": 1050,
	"./movie-pass-svg.svg": 708,
	"./movie-rolling.svg": 1051,
	"./mulitSchedule.svg": 1052,
	"./multicurrency.svg": 1053,
	"./multifnb.svg": 1054,
	"./nav-plus.svg": 1055,
	"./new_filter_icon.svg": 1056,
	"./no-image.svg": 1057,
	"./no-schedule.svg": 143,
	"./non-veg-mark.png": 1058,
	"./non-veg-mark.svg": 1059,
	"./notification.svg": 1060,
	"./open-link-blue.svg": 1061,
	"./openPlanned.svg": 1062,
	"./overview.svg": 1063,
	"./overview2.svg": 1064,
	"./pdf-icon.svg": 1065,
	"./pdf.svg": 1066,
	"./pickup-ticket-icon.svg": 1067,
	"./pickupfnb.svg": 1068,
	"./play.svg": 1069,
	"./plus.svg": 1070,
	"./pointofsale-1.svg": 1071,
	"./pointofsale-2.svg": 1072,
	"./pointofsale.png": 1073,
	"./portfolio.svg": 1074,
	"./pos-fnb-no-itmes.svg": 712,
	"./pos-refresh.svg": 1075,
	"./primary/chevron-down.svg": 1076,
	"./primary/download.svg": 1077,
	"./primary/edit.svg": 1078,
	"./primary/filter.svg": 1079,
	"./primary/printer.svg": 1080,
	"./print-icon.svg": 1081,
	"./print.svg": 1082,
	"./question.svg": 1083,
	"./question1.svg": 1084,
	"./question2.svg": 727,
	"./question3.svg": 1085,
	"./recliner-1.svg": 1086,
	"./recliner.png": 1087,
	"./refund-icon.svg": 1088,
	"./reload-icon-pos.svg": 1089,
	"./reload-icon.svg": 1090,
	"./restore.svg": 1091,
	"./right-caret.svg": 1092,
	"./role-management-sidebar.svg": 1093,
	"./save.svg": 1094,
	"./schedule-icon.svg": 1095,
	"./school-calendar.svg": 1096,
	"./search-global-white.svg": 1097,
	"./search-global.svg": 1098,
	"./search.svg": 1099,
	"./searchIcon.svg": 1100,
	"./seat-icon-2.svg": 1101,
	"./seat-icon.svg": 1102,
	"./seat-icons/3-wheelChair.png": 1103,
	"./seat-icons/block_seat_new.png": 1104,
	"./seat-icons/broken-seat-1.svg": 1105,
	"./seat-icons/broken-seat-2.svg": 1106,
	"./select-food.png": 728,
	"./settings.svg": 1107,
	"./show-password.svg": 369,
	"./slider-triangle.svg": 721,
	"./snack.svg": 722,
	"./sort.svg": 1108,
	"./star-empty.svg": 1109,
	"./star-fill.svg": 1110,
	"./success-tick.svg": 1111,
	"./suitcase.svg": 1112,
	"./swap.svg": 1113,
	"./tick-green-item.svg": 729,
	"./tick-green.svg": 1114,
	"./ticket-icon.svg": 1115,
	"./trash.svg": 1116,
	"./unpaid-reservation.svg": 704,
	"./updown-white.svg": 1117,
	"./updown.svg": 1118,
	"./user-attribute.svg": 1119,
	"./user-attributes.svg": 1120,
	"./user-female.svg": 1121,
	"./user-male-white.svg": 1122,
	"./user-male.svg": 1123,
	"./user-profile.svg": 1124,
	"./userProfile.png": 1125,
	"./veg-food-mark-white.png": 1126,
	"./veg-foog-mark-trans.png": 1127,
	"./view.png": 1128,
	"./view.svg": 1129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 950;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 950
// module chunks = 37